module.exports = __webpack_public_path__ + "static/24-eacedf9b3c224c0c7d8b648d800c2a06.jpg";